module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_vm._v("CONTENTS"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page5"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Dramatis_Personae"
    }
  }, [_vm._v("Dramatis Personae")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Prologue"
    }
  }, [_vm._v("Prologue: 16 March 1917")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction"
    }
  }, [_vm._v("Introduction: The Navy at War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Part01"
    }
  }, [_c('b', [_vm._v("Part One: The German auxiliary Cruiser "), _c('i', [_vm._v("Guerre de Course")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter01"
    }
  }, [_vm._v("1   A Change of Strategy, 1914")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2   Cruiser Warfare")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3   The Escapee, 1914")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4   Dancing Elephants, 1914")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5   The Weary Traveller, 1914–1915")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6   Enter the U-boat, 1914–1916")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7   The Seagull, 1915–1917")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Two: Blockade")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8   The Northern Patrol, 1914")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9   Enter the Merchantmen, 1914–1915")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 The Volunteers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Captains Courageous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 On Patrol, 1915–1916")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 The Long Duty Ends, 1916–1917")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Blockade and Trade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Three: A Desperate Battle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 "), _c('i', [_vm._v("Yarrowdale")]), _vm._v(" and Prisoners, 1916–1917")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Of Ships and Men, 1917")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 First Contact, March 1917")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Battle, March 1917")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Four: Endings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Secrets and Rewards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Postscript")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Coda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendices")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Appendix01#Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Moewe")]), _vm._v("’s Victims")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Armed Merchant Cruisers of the 10th Cruiser Squadron")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example of a T.124 Form")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Appendix04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Principles of Merchant Ship Construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Appendix05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Andersons in the Shetlands, HMS "), _c('i', [_vm._v("Dundee")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Select_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 69
// module chunks = 0